export default __webpack_public_path__ + "static/media/moovsMark.c5eb006f.svg";